import "@/lotteries/streaming/streaming-lib";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { sazkaAlert } from "@sazka/utils/sazka-alert";
import { StreamPlayerDefinition } from "./stream-player-definition";

declare function loadPlayerWithData(data: any, options: any): void;
const functionsBitMap = 66319802; // with pause status
// const functionsBitMap = 402857; // without pause status
// const functionsBitMap = 402857; // with seek bar
// const functionsBitMap = 66846719; // nothing

const url =
    environment.env == "Production"
        ? "https://apps.quickmedia.tv/api/playerembed?id=78078"
        : "https://apps-test.quickmedia.tv/api/playerembed?id=78078";

let streamData: any;

const getStreamData = () => {
    return new Promise(async (res, rej) => {
        if (streamData) res(streamData);
        try {
            const response = await httpClient.get(url);
            streamData = response.data;
            res(streamData);
        } catch (e) {
            rej(e);
        }
    });
};

const isBlockedTime = () => {
    const now = new Date();
    return now.getHours() == 0 && now.getMinutes() == 0 && now.getSeconds() < 10;
};

export const openLotteryVideoStream = (container: HTMLElement, dontCloseOnMidnight = false) => {
    return new Promise<StreamPlayerDefinition>(async (res, rej) => {
        let player: any;
        let interval: number;
        const close = () => {
            container.innerHTML = "";
            if (interval) {
                clearInterval(interval);
                interval = null;
            }
        };
        if (!dontCloseOnMidnight) {
            interval = window.setInterval(() => {
                if (isBlockedTime()) {
                    close();
                    sazkaAlert(
                        "Technická přestávka",
                        "Z důvodu technické přestávky bude další slosování rychlých loterií až v 00:10."
                    );
                }
            }, 5000);
        }

        const setVideoQuality = (resolution: 432 | 576 | 720 | 1080) => {
            if (!player) return;
            player.triggerCommand("setVideoQuality", resolution);
        };

        const toggleConfiguration = () => {
            if (!player) return;
            player.triggerCommand("toggleConfigurator");
        };

        const toggleFullscreen = () => {
            if (!player) return;
            player.triggerCommand("toggleFullscreen");
        };

        try {
            const streamData = await getStreamData();
            window["onPlayerInitialized"] = function () {
                player = (this as any)?.instance;

                if (player?.events) {
                    player.events.onMediaChanged(() => {
                        player.localSettings.setPlayedTime(player.mediaInfos[0].identity, 0);
                    });

                    player.events.onMediaLoad(() => {
                        if (ResponsiveUtils.isMobile()) {
                            setVideoQuality(576);
                        }
                    });
                }

                const video = player._videoElement as HTMLVideoElement;
                video.playsInline = true;
                video.autoplay = true;
                video.muted = true;

                if (ResponsiveUtils.isMobile() && ResponsiveUtils.isIos()) {
                    // not working correctly on iOS - due to fullscreen conflict
                    video.onpause = () => video.play();
                }

                res({
                    close,
                    setVideoQuality,
                    toggleConfiguration,
                    toggleFullscreen,
                });
            };

            loadPlayerWithData(streamData, {
                embed: container,
                settings: { playerVisibilities: functionsBitMap },
            });
        } catch (e) {
            rej(e);
        }
    });
};
